'use strict';
require('classlist-polyfill'); // classlist: IE9
require('console-polyfill'); // console: IE9
require('raf').polyfill(); // requestAnimationFrame: IE9, Android < 4.4
require('html5-history-api'); // HTML5 History: IE9.
// Pulled from node_modules/angular2/es6/src/dev/testing/shims_for_IE.js to
// work around https://github.com/angular/angular/issues/#6501.
// To be re-evaluated once that issue is closed.
// function.name (all IE)
// ! @source http://stackoverflow.com/questions/6903762/
//     function-name-not-supported-in-ie*/
// *! @source https://github.com/justindujardin/angular/
//     commit/1fdb099a3509503a6c644744957a7ba3c5c46a0b*/
if (!Object.hasOwnProperty('name')) {
    Object.defineProperty(Function.prototype, 'name', {
        get: function getName() {
            var matches = this.toString()
                .match(/^\s*function\s*([a-zA-z\_\$]*)\s*\(/);
            var name = matches && matches.length > 1 ? matches[1] : '';
            // For better performance only parse once, and then cache the
            // result through a new accessor for repeated access.
            Object.defineProperty(this, 'name', { value: name });
            return name;
        },
    });
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2hpbXNfZm9yX0lFLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsic2hpbXNfZm9yX0lFLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLFlBQVksQ0FBQztBQUViLE9BQU8sQ0FBQyxvQkFBb0IsQ0FBQyxDQUFDLENBQUMsaUJBQWlCO0FBQ2hELE9BQU8sQ0FBQyxrQkFBa0IsQ0FBQyxDQUFDLENBQUcsZUFBZTtBQUM5QyxPQUFPLENBQUMsS0FBSyxDQUFDLENBQUMsUUFBUSxFQUFFLENBQUMsQ0FBSyw0Q0FBNEM7QUFDM0UsT0FBTyxDQUFDLG1CQUFtQixDQUFDLENBQUMsQ0FBRSxzQkFBc0I7QUFFckQsMkVBQTJFO0FBQzNFLCtEQUErRDtBQUMvRCxnREFBZ0Q7QUFFaEQseUJBQXlCO0FBQ3pCLHdEQUF3RDtBQUN4RCwwQ0FBMEM7QUFDMUMsd0RBQXdEO0FBQ3hELHdEQUF3RDtBQUV4RCxFQUFFLENBQUMsQ0FBQyxDQUFDLE1BQU0sQ0FBQyxjQUFjLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxDQUFDO0lBQ25DLE1BQU0sQ0FBQyxjQUFjLENBQUMsUUFBUSxDQUFDLFNBQVMsRUFBRSxNQUFNLEVBQUU7UUFDaEQsR0FBRyxFQUFFO1lBQ0gsSUFBTSxPQUFPLEdBQUcsSUFBSSxDQUFDLFFBQVEsRUFBRTtpQkFDNUIsS0FBSyxDQUFDLHFDQUFxQyxDQUFDLENBQUM7WUFDaEQsSUFBTSxJQUFJLEdBQUcsT0FBTyxJQUFJLE9BQU8sQ0FBQyxNQUFNLEdBQUcsQ0FBQyxHQUFHLE9BQU8sQ0FBQyxDQUFDLENBQUMsR0FBRyxFQUFFLENBQUM7WUFDN0QsNkRBQTZEO1lBQzdELHFEQUFxRDtZQUNyRCxNQUFNLENBQUMsY0FBYyxDQUFDLElBQUksRUFBRSxNQUFNLEVBQUUsRUFBRSxLQUFLLEVBQUUsSUFBSSxFQUFFLENBQUMsQ0FBQztZQUNyRCxNQUFNLENBQUMsSUFBSSxDQUFDO1FBQ2QsQ0FBQztLQUNGLENBQUMsQ0FBQztBQUNMLENBQUMifQ==


/*****************
 ** WEBPACK FOOTER
 ** ./shims/shims_for_IE.ts
 ** module id = 955
 ** module chunks = 1
 **/